import { createOwnUpStyle } from '../../style';
export var OwnUpColumnsStyle = createOwnUpStyle({});
export var OwnUpRowStyle = function OwnUpRowStyle(_ref) {
  var _ref$perRow = _ref.perRow,
      perRow = _ref$perRow === void 0 ? 1 : _ref$perRow;
  var maxWidth = "".concat(100 / perRow, "%");
  return createOwnUpStyle({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'left',
    flexBasis: 'auto',
    '& > *': {
      flexGrow: 1,
      maxWidth: maxWidth,
      overflowWrap: 'normal',
      whiteSpace: 'normal'
    }
  });
};